<sh-box id="upcoming-activities-box-1" background="surface" layout="vertical" elevation="none" style="height: 100%; flex-grow: 0;">

  <sh-box-header id="upcoming-activities-box-header-2" slot="header" padding-bottom="0">
    <sh-icon id="upcoming-activities-icon-open-tasks" icon="open-tasks" size="s"
      style="margin-left: -4px; margin-right: 4px; cursor: help;"
      (click)="openHelp('Upcoming-Services-Gen')"></sh-icon>
    <sh-text id="upcoming-activities-text-4" size="title-1" style="cursor: help;" (click)="openHelp('Upcoming-Services-Gen')">{{ 'upcomingActivities.widget.title' | transloco }}</sh-text>
  </sh-box-header>

  <sh-box-section id="upcoming-activities-box-section-5" style="height: 100%">

    @if (isLoading) {
      <div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
        <sh-spinner id="upcoming-activities-spinner-6" size="s"></sh-spinner>
      </div>
    }

    @if (!isLoading && upcomingservices) {

      <sh-list id="upcoming-activities-list-1" flat integrated>

        <!-- Pending MUs -->
        @if (upcomingservices.outstanding_mu !== 0 && upcomingservices.outstanding_mu !== null) {
          <sh-list-item id="upcoming-activities-list-item-mu" clickable
            icon="warning" icon-color="var(--warning-yellow)" icon-size="xs"
            [attr.label]="'upcomingActivities.widget.outstandingMUs' | transloco"
            [attr.info]="upcomingservices.outstanding_mu + ' ' + ('upcomingActivities.widget.open' | transloco)"
            (click)="onMaximize('MU')">
          </sh-list-item>
        }

        <!-- Pending PMs -->
        @if (upcomingservices.outstanding_pm !== 0 && upcomingservices.outstanding_pm !== null) {
          <sh-list-item id="upcoming-activities-list-item-pm" clickable
            icon="warning" icon-color="var(--warning-yellow)" icon-size="xs"
            [attr.label]="'upcomingActivities.widget.outstandingPMs' | transloco"
            [attr.info]="upcomingservices.outstanding_pm + ' ' + ('upcomingActivities.widget.open' | transloco)"
            (click)="onMaximize('PM')">
          </sh-list-item>
        }

        <!-- Active PSMs -->
        @if (upcomingservices.upcoming_psm !== 0 && upcomingservices.upcoming_psm !== null) {
          <sh-list-item id="upcoming-activities-list-item-psm" clickable
            icon="warning" icon-color="var(--warning-yellow)" icon-size="xs"
            [attr.label]="'upcomingActivities.widget.activePSMs' | transloco"
            [attr.info]="upcomingservices.upcoming_psm + ' ' + ('upcomingActivities.widget.open' | transloco)"
            (click)="onMaximize('PSM')">
          </sh-list-item>
        }

        <!-- All-clear state -->
        @if (!hasAnyPending) {
          <sh-list-item id="upcoming-activities-list-item-all-clear"
            icon="success" icon-color="var(--success-icon-color)" icon-size="xs">
            <sh-text id="upcoming-activities-text-all-clear" size="body-1">
              {{ 'upcomingActivities.widget.subtitleAllClear' | transloco }}
            </sh-text>
          </sh-list-item>
        }

      </sh-list>
    }

    @if (isError) {
      <sh-empty-state id="upcoming-activities-empty-state-error-retrieving-data" [attr.label]="'upcomingActivities.widget.error' | transloco" icon="error" icon-color="#ebebe"></sh-empty-state>
    }

    @if (isEmpty) {
      <sh-empty-state id="upcoming-activities-empty-state-no-data-found" [attr.label]="'upcomingActivities.widget.empty' | transloco" icon="information" icon-color="#ebebe"></sh-empty-state>
    }

  </sh-box-section>

  @if (!isLoading && upcomingservices) {
    <sh-box-footer id="upcoming-activities-box-footer-24" slot="footer" padding-top="0" padding-bottom="1rem">
      @if (getDeviceType() !== 'phone') {
        <sh-button id="upcoming-activities-button-view-all-details" [icon]="checkWidgetIcon()" (click)="onMaximize(null)"
          [disabled]="isEmpty" icon-position="right" icon-size="s" [attr.label]="'upcomingActivities.widget.viewDetails' | transloco" layout="compact" color="secondary"
          size="s"></sh-button>
      }
    </sh-box-footer>
  }

</sh-box>